const dispositivoPacienteInitialState = {
  dispositivoPaciente: {
    loading: false,
    error: null,
    data: null,
    delete: null,
    post: null,
    flgVinculado: false,
    transferir: null,
    preferencias: null,
  },
};

export default dispositivoPacienteInitialState;
